import { render, staticRenderFns } from "./KsButton.vue?vue&type=template&id=3d5c7594"
import script from "./KsButton.vue?vue&type=script&lang=js"
export * from "./KsButton.vue?vue&type=script&lang=js"
import style0 from "./KsButton.vue?vue&type=style&index=0&id=3d5c7594&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports